/**
 * @desc 删除oss文件
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export function request(params: API.report.test.clearOssFile.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/clearOssFile`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
